"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgedAvatar = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _BadgedAvatar = require("./BadgedAvatar.styles");
var _excluded = ["avatar", "badge", "size"];
/**
 * Composes an `Avatar` with `AvatarBadge`.
 *
 * @since 7.18.0
 */
var BadgedAvatar = function BadgedAvatar(_ref) {
  var avatar = _ref.avatar,
    badge = _ref.badge,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var avatarClone = /*#__PURE__*/(0, _react.cloneElement)(avatar, {
    size: size
  });
  var badgeClone = /*#__PURE__*/(0, _react.cloneElement)(badge, {
    size: size
  });
  return /*#__PURE__*/_react.default.createElement(_BadgedAvatar.StyledBadgedAvatar, rest, avatarClone, badgeClone);
};
exports.BadgedAvatar = BadgedAvatar;
BadgedAvatar.displayName = 'BadgedAvatar';
BadgedAvatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `Avatar` component.
   */
  avatar: _propTypes.default.node.isRequired,
  /**
   * The `AvatarBadge` component.
   */
  badge: _propTypes.default.node.isRequired,
  /**
   * The avatar size. Note that only larger sizes are supported.
   */
  size: _propTypes.default.oneOf(['xxl', 'xl', 'lg'])
} : {};
BadgedAvatar.defaultProps = {
  size: 'lg'
};